import { Injectable, inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type RouterStateSnapshot, Router } from '@angular/router';
import type { Observable } from 'rxjs';
import { AuthService } from '../../features/auth/_services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard  {
  authService = inject(AuthService);
  router = inject(Router);


  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if(this.authService.isLoggedIn === false && this.authService.isAdminLoggedIn === false) {
      this.router.navigate(['login'],{skipLocationChange: true})
    }
    return true;
  }

}